import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import gameStateInputFromActions from '../../actions/gameStateInput';
import { __ } from 'i18n-for-browser';
import PopUp from "../elements/PopUp";
import VideoButton from "../elements/VideoButton";
import QuestionButton from "./QuestionButton";

const { submitMyState, updateMyState } = gameStateInputFromActions;

class TaxItemContainer extends Component {
  static propTypes = {
    title: PropTypes.string,
    saving: PropTypes.bool,
    visible: PropTypes.bool,
    step: PropTypes.string,
    savingMessage: PropTypes.string,
    feedbackMessage: PropTypes.string,
    notificationCount: PropTypes.number,
    saved: PropTypes.bool,
    part: PropTypes.number,
    video: PropTypes.string,
    buitenLandDialog: PropTypes.any,
  };
  static defaultProps = {
    title: '',
    saving: false,
    visible: true,
    step: 'SIMULATION_TAX',
    savingMessage: 'saving...',
    feedbackMessage: 'feedback message',
    notificationCount: 0,
    saved: false,
    part: 0,
    video: '',
    buitenLandDialog: false,
    showSavePopup: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  closeSavePopup = (res) => {
    if(res) {
      const {props} = this;
      if (props.buttonConditions && props.user.role === 'groupleader' && !props.gameStateInput.preventInputChanges) {
        props.dispatch(submitMyState(props.step));
      }
    }
    this.setState({
      showSavePopup: false,
    })
  }

  render () {
    const { props } = this;

    return (
      <div className={'taxes-section' + (props.visible ? '' : ' inactive')}>
        { props.saving ?
          <PopUp isPortal={true} hideClose={true} showHeader={true} id={props.savingMessage} className={'imgCenter'}/>
          : null
        }
        { props.showSavedPopup ?
          <PopUp isPortal={true} hideClose={true} showHeader={true} id={props.feedbackMessage} className={'imgCenter'} buttonText={__('sim_bekijk_feedback')} closePopUpClick={() => {
            props.dispatch(updateMyState({ showSavedPopup: false }));
            this.setState({feedbackPopupDone: true});
          }}/>
          : null
        }
        { props.buitenLandDialog && this.state.feedbackPopupDone ?
          <PopUp
            isPortal={true}
            id={'dhgmstap2buitenland'}
            buttonText={__('sim_sluiten')}
            closePopUpClick={() => {
              this.setState({feedbackPopupDone: false});
            }}
          />
          : null
        }
        <h3><QuestionButton popupId={props.popupId}>{props.title} <span>{props.part ? ` | ${__('sim_deel')} ${props.part}` : ''} </span></QuestionButton> <VideoButton src={props.video}/></h3>
        {props.children}
            { !props.saved && this.props.user.role === 'groupleader' ?
              (props.project.difficulty === 'BASIC' ? (
                <div className={'savebutton-container'}>
                  <button
                    onClick={(ev) => {
                      ev.preventDefault();
                      this.setState({
                        showSavePopup: true
                      })
                    }}
                    className={`button${props.buttonConditions && !props.gameStateInput.preventInputChanges ? '' : ' disabled'}`}
                  >
                    <span>{__('sim_opslaan')}</span>
                  </button>
                  { this.state.showSavePopup ? (
                    <PopUp id={'dlgmstap3opslaan_1'} closePopUpClick={(res) => {this.closeSavePopup(res)}}/>
                  ) : null }
                </div>
              ) : (
                <div className={'savebutton-container'}>
                  <button
                    onClick={(ev) => {
                      ev.preventDefault();
                      if (props.buttonConditions && props.user.role === 'groupleader' && !props.gameStateInput.preventInputChanges) {
                        props.dispatch(submitMyState(props.step));
                      }
                    }}
                    className={`button${props.buttonConditions && !props.gameStateInput.preventInputChanges ? '' : ' disabled'}`}
                  >
                    <span>{__('sim_opslaan')}</span>
                  </button>
                </div>
              ))
            : null
          }
      </div>
    );
  }
}

export default connect(state => state)(TaxItemContainer);



// WEBPACK FOOTER //
// ./src/components/elements/TaxItemContainer.js